import { render, staticRenderFns } from "./DeletionRedirect.vue?vue&type=template&id=c7e0eda4&"
import script from "./DeletionRedirect.vue?vue&type=script&lang=js&"
export * from "./DeletionRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports